export const baseConfig = {
    //To do complete the config the axios
    baseURL:process.env.REACT_APP_API,
    timeout:3000,
    method: "GET",
    headers:null,
    paylod:null,//custom atrribute
    path:null //custom attribute
}